import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { TopicTypeDescriptions, TopicTypeLabels, TopicTypes } from "@seabrookstudios/pitch2table-core";
import CircularProgress from "@mui/material/CircularProgress";

const Label = "Topic Type";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").TopicType} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").TopicType) => void} props.onChange
 * @param {boolean} props.isPending
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 */
export const TopicTypeSelect = ({ value, onChange, helperText, disabled = false, isPending }) => {
  /**
   * @param {*} ev
   */
  const onChangeHandler = (ev) => {
    onChange(ev.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal" disabled={disabled}>
      <InputLabel id="topic-type">{Label}</InputLabel>
      <Select
        labelId="topic-type"
        value={value}
        onChange={onChangeHandler}
        placeholder={Label}
        label={Label}
        input={<OutlinedInput label={Label} />}
      >
        {isPending ? (
          <CircularProgress />
        ) : (
          TopicTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {TopicTypeLabels[type]} - {TopicTypeDescriptions[type]}
            </MenuItem>
          ))
        )}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
